import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import DashboardLayout from '../components/DashboardLayout.vue'

import ServicesView from '../views/ServicesView.vue'
import OpeningHoursView from '../views/OpeningHoursView.vue'
import ResourcesView from '../views/ResourcesView.vue'
import SkillsView from '../views/SkillsView.vue'
import OperatorsView from '../views/OperatorsView.vue'
import CustomersView from '../views/CustomersView.vue'
import AppointmentsView from '../views/AppointmentsView.vue'
import SettingsView from '../views/SettingsView.vue'
import VoucherManagement from '../views/VoucherManagement.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/login', name: 'login', component: LoginView, },
    {
      path: '/',
      component: DashboardLayout,
      children: [
        { path: 'services', name: 'services', component: ServicesView },
        { path: 'opening-hours', name: 'opening-hours', component: OpeningHoursView },
        { path: 'resources', name: 'resources', component: ResourcesView },
        { path: 'skills', name: 'skills', component: SkillsView },
        { path: 'operators', name: 'operators', component: OperatorsView },
        { path: 'customers', name: 'customers', component: CustomersView },
        { path: 'appointments', name: 'appointments', component: AppointmentsView },
        { path: 'settings', name: 'settings', component: SettingsView },
        { path: 'voucher', name: 'VoucherManagement', component: VoucherManagement },
      ]
    }
  ],
})

export default router
